import { ReactNode } from 'react';
import { useClientHasRendered } from '@domain/session/useClientHasRendered';
import ContentLoader from 'react-content-loader';
import { ShareIcon } from '../Icons/ShareIcon';

interface ShareButtonProps {
  buttonWidth?: number;
  buttonHeight?: number;
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
  parentComponent: string;
  shareData: ShareData;
}

export const ShareButton = ({
  buttonWidth = 24,
  buttonHeight = 24,
  children,
  className,
  onClick = () => {},
  parentComponent,
  shareData,
}: ShareButtonProps) => {
  const clientHasRendered = useClientHasRendered();
  const handleShareButtonClick = () => {
    const share = async () => {
      await navigator.share(shareData);
    };
    onClick();
    share().catch(() => {});
  };

  if (!clientHasRendered) {
    return (
      <ContentLoader width={buttonWidth} height={buttonHeight} uniqueKey="share-button">
        <rect x="0" y="0" rx="0" ry="0" width={buttonWidth} height={buttonHeight} />
      </ContentLoader>
    );
  }

  if (typeof navigator === 'undefined') {
    return <></>;
  }

  return (
    <button
      aria-label="share current page"
      className={className}
      data-testid={`share-btn-${parentComponent}`}
      onClick={handleShareButtonClick}
      type="button"
    >
      <div className="group relative">
        {children ?? <ShareIcon width={buttonWidth} height={buttonHeight} />}
      </div>
    </button>
  );
};
